import ModeratorCardDisplay from "./../ModerationCardDisplay";
import { useTranslation } from "react-i18next";

const LoadModeratorDisplay = ({
    listOfAllModerators,
    isButtonDisabled,
    addModerator,
    updateModerator,
    deleteModerator,
    manualApprovalState,
    replaceModerator,
}) => {
    const { t } = useTranslation("moderatorPage");

    let arr = [];

    if (listOfAllModerators.length)
        listOfAllModerators.forEach((item) => {
            // A unique key must be provided for the react -
            // component to render each element correctly
            // do not use index since the value will change on removal

            arr.push(
                <ModeratorCardDisplay
                    moderatorObject={item}
                    isButtonDisabled={isButtonDisabled}
                    addModerator={addModerator}
                    key={"moderatorDisplay" + item.id}
                    updateModerator={updateModerator}
                    deleteModerator={deleteModerator}
                    manualApprovalState={manualApprovalState}
                    replaceModerator={replaceModerator}
                />,
            );
        });

    const displayModerationLength = listOfAllModerators.length ? (
        <p>
            {t("moderatorsDisplay", {
                channels: `[ ${listOfAllModerators.length} ]`,
            })}
        </p>
    ) : (
        <></>
    );
    const displayModeratorArray = (
        <div className="moderationBroadcasterDisplayGlobal">{arr}</div>
    );

    return (
        <>
            {displayModerationLength}
            {displayModeratorArray}
        </>
    );
};
export default LoadModeratorDisplay;
